import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { EmiOption, Application } from '../../application/application';
import { BehaviorSubject } from 'rxjs';
import { ApplicationService } from 'app/application/application.service';
import { TokenService } from 'app/token/token.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { MerchantSetting } from '../../landing-pages/gift-card/gift-card';

declare var Materialize: any;

@Component({
  selector: 'zest-update-loan',
  templateUrl: './update-loan.component.html',
  styleUrls: ['./update-loan.component.scss']
})
export class UpdateLoanComponent implements OnInit, OnChanges {

  @Input() inView: boolean;
  @Input() newAmount: number;
  @Input() application: Application;
  @Input() isUpSell = false;
  @Input() headerText = 'Update Voucher';

  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() voucherUpdated: EventEmitter<EmiOption> = new EventEmitter<EmiOption>();

  @ViewChild('amount', {static: true}) amountElement: ElementRef;

  emiPlans: EmiOption[] = [];
  selectedPlan: EmiOption | null;
  productPrice: number;
  selectedEMIPlan: number | null;
  priceReceiver: BehaviorSubject<number>;
  maxAllowedVoucherAmount = 0;
  minAllowedVoucherAmount = 0;
  productPriceInRange = true;
  merchantSettings: MerchantSetting[];
  rupeeCommaNumberMask = {
    mask: createNumberMask({
      prefix: '',
      suffix: '',
      keepCharPositions: true
    }),
    guide: false
  };

  constructor(
    private applicationService: ApplicationService,
    private tokenService: TokenService
  ) { }

  ngOnInit() {
    this.merchantSettings = this.tokenService.getMerchantSettings();
    this.maxAllowedVoucherAmount = this.newAmount;
    const merchantSetting = this.merchantSettings.find(merchant => merchant.partnerName.toLowerCase() === this.application.MerchantName.toLowerCase());
    this.minAllowedVoucherAmount = merchantSetting ? merchantSetting.minLimit : 0;
    if (this.isUpSell && this.application.LoanAmount >= this.minAllowedVoucherAmount) {
      this.minAllowedVoucherAmount = this.application.LoanAmount + 1;
    }
    this.priceReceiver = new BehaviorSubject<number>(this.maxAllowedVoucherAmount);
    this.priceReceiver.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((productPrice) => {
      this.selectedPlan = null;
      this.selectedEMIPlan = null;
      this.getEmiPlans(productPrice);
    });
  }

  ngOnChanges() {
    if (this.inView) {
      this.amountElement.nativeElement.focus();
    }
  }

  updatePrice($event) {
    this.priceReceiver.next($event);
  }

  getEmiPlans(amt: any) {
    this.emiPlans = null;
    this.productPriceInRange = false;
    this.productPrice = isNaN(amt) ? Number(String(this.productPrice).split(',').join('')) : amt;
    const amount = Number(String(amt).split(',').join(''));
    if (!isNaN(amount)) {
      if (Number(amount) >= this.minAllowedVoucherAmount && Number(amount) <= this.maxAllowedVoucherAmount) {
        this.productPriceInRange = true;
        this.applicationService.getRecommendedAndOtherEMIPlans(this.application.MerchantId, amount, null).subscribe(response => {
          this.emiPlans = (response.OtherEmiOptions ? response.RecommendedEmiOptions.concat(response.OtherEmiOptions) : response.RecommendedEmiOptions).sort(this.applicationService.sortEmiOptionsByNumberOfMonths);
          if (this.selectedPlan) {
            this.selectMonths(this.selectedEMIPlan);
          }
        }, error => {
          this.tokenService.removeAllToasts();
          Materialize.toast('Something went wrong. Please try again.', 5000, 'rounded', () => { this.tokenService.removeAllToasts(); });
        });
      } else {
        this.productPriceInRange = false;
      }
    }
  }

  selectMonths(months: number) {
    this.selectedPlan = this.emiPlans.find(plan => plan.NumberOfMonths === Number(months));
  }

  updateLoanAmount(selectedPlan) {
    this.voucherUpdated.emit(selectedPlan);
  }

  closeView() {
    this.close.emit(true);
  }

}
